import { motion } from "framer-motion";

export default function GlassCard({
  children,
  className = "",
  delay = 0,
}) {
  return (
    <motion.div
      className={`rounded-2xl item-border border-white/10 bg-gradient-card backdrop-blur-sm p-6 md:p-8 ${className}`}
      initial={{ opacity: 0, scale: 0.95 }}
      whileInView={{ opacity: 1, scale: 1 }}
      viewport={{ once: true }}
      transition={{
        duration: 0.5,
        delay,
        ease: "easeOut",
      }}
      whileHover={{ scale: 1.02 }}
    >
      {children}
    </motion.div>
  );
}
